import React, { useEffect, useState } from "react";
import axios from "axios";
import "./clientBookingDetails.css";
import ClientLaundryImages from "./ClientLaundryImages";

const itemPriority = [
    'Bedsheet',
    'Small Bedsheet',
    'Super King Bedsheet',
    'Duvet Cover',
    'Small Duvet Cover',
    'Super King Duvet Cover',
    'Pillowcase',
    'Bath Towel',
    'Hand Towel',
    'Face Towel',
    'Bathmat',
    'Beach Towel',
];

const ClientBookingLaundry = ({ bookingId }) => {
    const [laundryData, setLaundryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [noLaundry, setNoLaundry] = useState(false);

    useEffect(() => {
        const fetchLaundry = async () => {
            try {
                const response = await axios.get(`/api/client-requests/bookings/laundry-details/${bookingId}`);
                const items = response.data.items;

                if (!items || items.length === 0) {
                    setNoLaundry(true);
                } else {
                    const sortedItems = [...items].sort((a, b) => {
                        const indexA = itemPriority.indexOf(a.item_name);
                        const indexB = itemPriority.indexOf(b.item_name);

                        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                        if (indexA !== -1) return -1;
                        if (indexB !== -1) return 1;
                        return a.item_name.localeCompare(b.item_name);
                    });

                    setLaundryData(sortedItems);
                }
            } catch (err) {
                setError("Failed to fetch laundry details.");
            } finally {
                setLoading(false);
            }
        };

        fetchLaundry();
    }, [bookingId]);

    if (loading) return <div className="client-loading">Loading laundry summary...</div>;
    if (error) return <div className="client-error-message">{error}</div>;
    if (noLaundry) return <p className="client-no-reports">No laundry records available</p>;

    return (
        <div>
            <table className="laundry-details-table">
                <thead>
                    <tr>
                        <th style={{ textAlign: 'left' }}>Item Name</th>
                        <th>Drop-off</th>
                        <th>Pickup</th>
                    </tr>
                </thead>
                <tbody>
                    {laundryData.map(item => (
                        <tr key={item.laundry_item_id}>
                            <td style={{ textAlign: 'left' }}>{item.item_name}</td>
                            <td>{item.dropoff}</td>
                            <td>{item.pickup}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <ClientLaundryImages bookingId={bookingId} />
        </div>
    );
};

export default ClientBookingLaundry;